import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';
import './ActivityTopBar.css';

const ActivityTopBar = ({ title, onBack, right, className, expanded = false }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { resolvedDirection } = useLanguage();
  const isLtr = resolvedDirection === 'ltr';

  const handleBack = () => {
    if (typeof onBack === 'function') return onBack();
    navigate(-1);
  };

  return (
    <div
      className={`activity-top-bar ${theme === 'dark' ? 'theme-dark' : ''} ${isLtr ? 'atb-ltr' : ''} ${expanded ? 'atb-expanded' : ''} ${className || ''}`}
      dir={resolvedDirection}
    >
      {!expanded && <button className="atb-back" onClick={handleBack} aria-label="back">
        {isLtr ? <ArrowLeft size={20} /> : <ArrowRight size={20} />}
      </button>}
      {right && (
        <div className="atb-right">
          {right}
        </div>
      )}
      {!expanded && <h1 className="atb-title">{title}</h1>}
    </div>
  );
};

export default ActivityTopBar;